import React from 'react';

function formatAmount(cents) {
  const dollars = (cents || 0) / 100;
  return `$${dollars.toFixed(2)}`;
}

export default function PriceIntervalCell({ amountCents, interval }) {
  const label = interval === 'year' ? 'year' : 'month';
  return <span>{formatAmount(amountCents)} / {label}</span>;
}
